import { render, staticRenderFns } from "./ViewAppointment.vue?vue&type=template&id=dbbf9002&scoped=true&"
import script from "./ViewAppointment.vue?vue&type=script&lang=js&"
export * from "./ViewAppointment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbbf9002",
  null
  
)

export default component.exports